import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar";
import Navbar from "../Navbar";
import Cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";
import Config from "../Config";
import ReactPaginate from "react-paginate";
import { ToastContainer, toast } from "react-toastify";
import { useAuthHandling } from '../useAuthhandling';
import Deletemodal from "../Deletemodal";
import Nodatafound from "../Nodatafound";

function Contact() {
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  let navigate = useNavigate();
  const[pageindex,setPageindex]=useState(1);
  const [pagenum,setPagenum]=useState(1);

  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [messagedata, setEnquiry] = useState([]);
  const [count, setPagecount] = useState('');

  const [modal_animationFlip, setmodal_animationFlip] = useState(false);
  const [pageid, setPageid] = useState("");

  function tog_animationFlip(id) {
    setmodal_animationFlip(!modal_animationFlip);
    setPageid(id)
  }

  const getinfo = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/enquiry/get-enquiries`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200) {
      const data = await res.json();

      setEnquiry(data.data[0].enquires[0].data);
      setPagecount(data.data[0].enquires[0].totalPages);

    }
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };

  const DeleteData= async (id)=> {
    setmodal_animationFlip(false);

    const response = await fetch(
      `${Config.apiurl}/api/v1/crm/enquiry/delete-enquiry/${id}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );


    if (response.status === 200 ) {
      const deletedata = await response.json();

      toast.success("Enquiry deleted", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handlePageClick(pagenum);
    }
    else if(response.status === 401){
      handleUnauthorized();
      DeleteData(id);
    }
    else {
     console.log("error");
    }
  }
  useEffect(() => {
    getinfo();
  }, []);

  const fetchComments = async (currentPage) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/enquiry/get-enquiries?page=${currentPage}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200 ) {

    const data = await res.json();
    return data.data[0].enquires[0].data;
    }
    else if(res.status === 401){
      handleUnauthorized();
      fetchComments(currentPage);
    }
  };

  const handlePageClick = async (data) => {
    if(data===1){
      setPageindex(1);

      setPagenum(data);
      const commentsFormServer = await fetchComments(data);
      setEnquiry(commentsFormServer);
    }
    else{
    let currentPage = data.selected + 1;
    setPageindex(currentPage);

    setPagenum(data);
    const commentsFormServer = await fetchComments(currentPage);

    setEnquiry(commentsFormServer);
    }
  };
  return (
    <div>
      <div className="container-scroller">
        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          {/* partial */}
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-lg-12 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">Enquiry Messages</h4>
                      <div className="table-responsive pt-3">
                      {messagedata?.length>0?
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>Sl No</th>
                              <th>Customer Name</th>

                              <th>Enquiry Type</th>
                              <th>Category Name/Professional Name</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {messagedata.map((element, i) => {
                              return (
                                <>
                                  <tr>
                                    <th scope="row">{pageindex===1 ? i+1: (pageindex-1) * 10 + i +1}</th>
                                    <td>{element?.customerInfo[0]?.name}</td>
                                    <td>{element.enquiryType}</td>
                                    {element.enquiryType==='Direct-enquiry'?
                                    element?.professionalInfo?.length > 0 ? (
                                      <td>
                                        {element?.professionalInfo[0]?.name}
                                      </td>
                                    ) : (
                                      <td></td>
                                    )
                                    :
                                    element?.enquiryCategoryName? (
                                      <td>{element?.enquiryCategoryName}</td>
                                    ):<td></td>
                                  }
                                  
                          
                                    {/* <td>{element.enquiryCategoryName}</td> */}
                                    {/* {element.professionalCategoryResult.length >
                                    0 ? (
                                      <td>
                                        {
                                          element.professionalCategoryResult[0]
                                            .serviceName
                                        }
                                      </td>
                                    ) : (
                                      <td></td>
                                    )} */}
                                    <td  className="actions_td">
                                      {" "}
                                      <Link                                      
                                        className="action_icons"
                                        onClick={() => tog_animationFlip(element._id)}
                                      >
                                        <i className="fa-solid fa-trash" />
                                      </Link>                                   
                                        <Link
                                          to={`/editenquiry/${element._id}`}
                                          className="fa-solid fa-pen action_icons"
                                          
                                        ></Link>
                                              <Link to={"/enquiryview/" + element._id}  className="action_icons">
                                             <i className="fa-solid fa-eye" />
                                             </Link>                                        
                                        <ToastContainer />
                                    </td>
                                  </tr>
                                </>
                              );
                            })}
                          </tbody>
                        </table>
                        :
                        <Nodatafound/>
                      }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {count > 1 ? (
                <ReactPaginate
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  breakLabel={"..."}
                  pageCount={count}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
      {modal_animationFlip ? (
          <Deletemodal
            modal_animationFlip={modal_animationFlip}
            tog_animationFlip={tog_animationFlip}
            pageid={pageid}
            DeleteData={DeleteData}
            message={"Enquiry"}
          />
        ) : (
          ""
        )}
    </div>
  );
}

export default Contact;
